iScreenWizard.controller('FeedbackgeversController', function ($scope, $state, $mdDialog, $filter, Ajax, ErrorHandler, Dictionary, userService, Taal, nieuwe360FeedbackService) {

    $scope.userService = userService;
    $scope.feedback = nieuwe360FeedbackService.model;
    $scope.talen = [];
    $scope.canContinue = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        if (typeof $scope.feedback.feedbackgevers == 'undefined') {
            $scope.feedback.feedbackgevers = [];
            $scope.addFeedbackgever();
        }

        Taal.all().then(function (talen) {
            $scope.talen = talen;
        });

        $scope.checkContinue();
    };

    $scope.addFeedbackgever = function() {
        $scope.feedback.feedbackgevers.push({
            voornaam: '',
            achternaam: '',
            email: '',
            taal_id: 1,
            functie: ''
        });
        $scope.canContinue = false;
        nieuwe360FeedbackService.SaveState();
    };

    $scope.deleteFeedbackgever = function(feedbackgever) {
        var index = $scope.feedback.feedbackgevers.indexOf(feedbackgever);
        $scope.feedback.feedbackgevers.splice(index, 1);
        nieuwe360FeedbackService.SaveState();
        $scope.checkContinue();
    };

    $scope.checkContinue = function() {
        $scope.canContinue = true;
        angular.forEach($scope.feedback.feedbackgevers, function(feedbackgever, key) {
            if (typeof feedbackgever.voornaam == 'undefined' || feedbackgever.voornaam.length < 1 ||
                typeof feedbackgever.achternaam == 'undefined' || feedbackgever.achternaam.length < 1 ||
                typeof feedbackgever.email == 'undefined' || feedbackgever.email.length < 1 ||
                typeof feedbackgever.taal_id == 'undefined' || feedbackgever.taal_id < 1) {
                $scope.canContinue = false;
            }
        });
    }

    $scope.saveFeedbackgevers = function() {
        if ($scope.canContinue) {
            nieuwe360FeedbackService.SaveState();
            $state.go('360-feedback/uitnodiging');
        }
    }

});